import React, { useRef, useState } from "react";
import SavedLocationsModal from "../../components/modals/SavedLocationsModal";
import YuJaButton from "../../components/standardization/YuJaButton";
import { YuJaDropdown } from "../../components/standardization/YuJaDropdown";
import { YuJaRadioBox } from "../../components/standardization/YuJaRadiobox";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import {ReactComponent as PollDetailsIcon} from "../../images/poll_details.svg";
import {ReactComponent as QuestionDetailsIcon} from "../../images/question_details.svg";
import {ReactComponent as ToastIcon} from "../../images/toast_icon.svg";

import {
    ATMPT_DROPDOWN,
    CLASS_RESULT_DURATION_LABEL,
    COUNTDOWN_TIMER_LABEL,
    DEFAULT_ATTENDANCE_SAVED_LOCATIONS,
    DEFAULT_CLASS_RESULT_TIME_LIMIT,
    DEFAULT_ENTRIES_PER_PARTICIPANT,
    DEFAULT_GET_READY_ALL_TIME_LIMIT,
    DEFAULT_GET_READY_TIME_LIMIT,
    DEFAULT_POINTS,
    DEFAULT_POLL_BREAK_TIME_LIMIT,
    DEFAULT_TIME_LIMIT,
    LMS_GRADEBOOK_SYNC,
    MAXIMUM_ENTRIES_LABEL,
    PARTICIPANT_TIME_INTRO,
    POLL_ATTEMPT_SETTINGS_TEXT,
    POLL_BREAK_DURATION_LABEL,
    QUESTION_DETAILS_SETTINGS,
    QUESTION_DURATION_LABEL,
    QUESTION_POINT_LABEL,
    RADIAL_LABEL,
    RECORD_ATTEMPT,
    RECORD_ATTEMPT_TITLE,
    SYNC_ATTEMPT,
    TEXTBOX,
    TOAST_DROPDOWN,
    TOAST_MESSAGE_SETTINGS,
    UNLIMITED_MAX_ATTEMPTS_SETTING_TEXT,
    USER_QUESTION_MESSAGE_LABEL,
    USER_SETTINGS,
    USER_TOAST_MESSAGE_LABEL,
    WC_MAXIMUM_ENTRIES,
    GEOFENCED_LOCATIONS_TITLE,
    ATTENDANCE_SETTINGS_GEO_LOCATION_SUB_TITLE,
    YUJA_DROPDOWN_SIZE,
    CONFIGURE_LOCATIONS_TEXT,
    QUESTION_COUNTDOWN_TIMER_DESCRIPTION,
    MAXIMUM_ENTRIES_DESCRIPTION,
    QUESTION_DURATION_DESCRIPTION,
    QUESTION_POINT_DESCRIPTION,
    POLL_COUNTDOWN_TIMER_DESCRIPTION,
    REQUIRE_PARTICIPANTS_NAME,
    REQUIRE_PARTICIPANTS_NAME_DESCRIPTION,
    SHOW_CORRECT_ANSWER,
    SHOW_CORRECT_ANSWER_DESCRIPTION,
    GRADE_BOOK_TEXT,
    ATTEMPT_SYNC_TO_GRADE_BOOK_DESCRIPTION,
    ACTIVITY_DETAILS_SETTINGS,
    ACTIVITY_DETAILS_SETTINGS_DESCRIPTION,
    ACTIVITY_LENGTH_SETTING_TEXT,
    ACTIVITY_LENGTH_SETTING_DESC,
    PARTICIPANTS_VIEW_CLASS_RESULT_DESCRIPTION,
    DEFAULT_POLL_TIME_LIMIT,
    DEFAULT_ATTENDANCE_TIME_LIMIT,
    ACTIVITY_TIME_LIMIT_TEXT,
    ACTIVITY_TYPE_PLACEHOLDER,
    POLL_TEXT, ACTIVITY_TEXT, POLL_END_FLEXIBLE_TIME_DESCRIPTION, DEFAULT_COUNT_DOWN_TIME_LIMIT
} from "../../utils/constants";
import {deCapitalizeWord, notifyError, notifySuccess} from "../../utils/helpers";

import {
    CUSTOM_TIME_LIMIT_MAX_ERROR,
    CUSTOM_TIME_LIMIT_MINUTES_FORMAT_ERROR,
    CUSTOM_TIME_LIMIT_MIN_ERROR,
    MINIMUM_CLASS_RESULT_DURATION_SETTING_ERROR,
    MINIMUM_POLL_BREAK_DURATION_SETTING_ERROR,
    SAVE_SETTINGS_SUCCESS,
    SETTINGS_QUESTION_ENTRIES_MAX_ERROR, SETTINGS_QUESTION_ENTRIES_MIN_ERROR, MINIMUM_COUNT_DOWN_SETTING_ERROR
} from "../../utils/toast-message-constants";
import classes from "./Settings.module.css";
import {UserApiCalls} from "../../apis/UserApiCalls";
import {YuJaToggle} from "../../components/standardization/YuJaToggle";
import DropdownTimeLimit from "../../components/DropdownTimeLimit";
import DropdownWeightage from "../../components/DropdownWeightage";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import TimeLimitInput from "../../components/TimeLimitInput";

export default function UserSettingTab({userSettings, setUserSettings, isViewer=false}) {
    const [, getSession] = useLocalStorageNew("session", {});
    const session = getSession();
    const [showSavedLocationModal, setShowSavedLocationModal] = useState(false);
    // savedLocations is an array of {name: string, lat: number, lng: number, rad: number}
    const [savedLocations, setSavedLocations] = useState(JSON.parse(userSettings && userSettings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS) ? userSettings[USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS] : DEFAULT_ATTENDANCE_SAVED_LOCATIONS));
    const optionArr = [
        {value: "5", label: "5 Seconds"},
        {value: "10", label: "10 Seconds"},
        {value: "-1", label: "Dismiss Manually"},
    ];

    const attemptSettingsArr = [
        LMS_GRADEBOOK_SYNC.FIRST,
        LMS_GRADEBOOK_SYNC.RECENT,
        LMS_GRADEBOOK_SYNC.HIGHEST
    ];
    const recordAttemptOptions = useRef([ RECORD_ATTEMPT.ALL, RECORD_ATTEMPT.RECENT ]);

    const [maxAttempts, setMaxAttempts] = useState(!!userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS]
        ? `${userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS]}`
        : "-1"
    );

    const {saveSettings} = UserApiCalls();

    const onSelect = (item, setting) => {
        const copy = JSON.parse(JSON.stringify(userSettings));
        copy[USER_SETTINGS.TOAST_MESSAGE_DURATION] = item.value;
        setUserSettings(copy);
    };

    const handleAttendanceManualEndChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(userSettings));
        copy[USER_SETTINGS.ATTENDANCE_MANUAL_END] = input.checked;
        if (!copy[USER_SETTINGS.POLL_DURATION]) {
            copy[USER_SETTINGS.POLL_DURATION] = DEFAULT_POLL_TIME_LIMIT;
        }

        if (!copy[USER_SETTINGS.ATTENDANCE_DURATION]) {
            copy[USER_SETTINGS.ATTENDANCE_DURATION] = DEFAULT_ATTENDANCE_TIME_LIMIT;
        }
        setUserSettings(copy);
    };



    const handleAnonymousJoinSettingChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(userSettings));
        copy[USER_SETTINGS.POLL_REQUIRED_NAME] = input.checked;
        setUserSettings(copy);
    };

    const handleCorrectAnswerChange = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(userSettings));
        copy[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] = input.checked;
        setUserSettings(copy);
    };
    
    const handleLMSAttemptSettingChange = (item) => {
        const copy = JSON.parse(JSON.stringify(userSettings));
        copy[USER_SETTINGS.POLL_LMS_SYNC] = item.value;
        setUserSettings(copy);
    };

    const handleToggleQuestionPoints = (e) => {
        const input = e.currentTarget;
        if (input.checked) {
            const copy = JSON.parse(JSON.stringify(userSettings));
            copy[USER_SETTINGS.QUESTION_POINTS] = DEFAULT_POINTS;
            setUserSettings(copy);
            // if (!customPoints) {
            // }
        } else {
            const copy = JSON.parse(JSON.stringify(userSettings));
            copy[USER_SETTINGS.QUESTION_POINTS] = 0;
            setUserSettings(copy);
            // setCustomPoints(0);
        }
    };

    const handleToggleQuestionDuration = (e) => {
        const input = e.currentTarget;
        if (input.checked) {
            const copy = JSON.parse(JSON.stringify(userSettings));
            copy[USER_SETTINGS.QUESTION_DURATION] = DEFAULT_TIME_LIMIT;
            setUserSettings(copy);

        } else {
            const copy = JSON.parse(JSON.stringify(userSettings));
            copy[USER_SETTINGS.QUESTION_DURATION] = 0;
            setUserSettings(copy);
        }
    };

    const onChangeCustomEntries = (e) => {
        const copy = JSON.parse(JSON.stringify(userSettings));
        copy[USER_SETTINGS.QUESTION_ENTRIES] = e.target.value;

        setUserSettings(copy);
    };

    const onChangeCustomGetReadyTime = (event) => {
        let value = event.target.value.replace(/[^0-9]/g, '');
        value = parseInt(value, 10);
        const copy = JSON.parse(JSON.stringify(userSettings));
        if(!isNaN(value) && value < 100 && value > 0) {
            copy[USER_SETTINGS.QUESTION_COUNTDOWN] = value;
        }
        else {
            copy[USER_SETTINGS.QUESTION_COUNTDOWN] = "";
        }
        setUserSettings(copy);
    };

    const OnChangePollCountDown = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, '');
        value = parseInt(value, 10);
        const copy = JSON.parse(JSON.stringify(userSettings));
        if(!isNaN(value) && value < 100 && value > 0) {
            copy[USER_SETTINGS.POLL_COUNTDOWN] = value;
        }
        else {
            copy[USER_SETTINGS.POLL_COUNTDOWN] = "";
        }
        setUserSettings(copy);
    }

    const onChangeMaximumAttempts = (e) => {
        const input = e.currentTarget;
        const copy = JSON.parse(JSON.stringify(userSettings));
        if (e.target.checked) {
            copy[USER_SETTINGS.POLL_MAX_ATTEMPTS] = -1;
            setMaxAttempts(-1);
        }
        else {
            copy[USER_SETTINGS.POLL_MAX_ATTEMPTS] = 1;
            setMaxAttempts(1);
        }
        setUserSettings(copy);
    }

    const handleRecordAttemptOptionClick = (value) => {
        const copy = JSON.parse(JSON.stringify(userSettings));
        if (value === RECORD_ATTEMPT.RECENT.value) {
            copy[USER_SETTINGS.POLL_RECORD_ATTEMPTS] = SYNC_ATTEMPT.RECENT.value;
            copy[USER_SETTINGS.POLL_LMS_SYNC] = LMS_GRADEBOOK_SYNC.RECENT.value; 
        } else if (value === RECORD_ATTEMPT.ALL.value) {
            copy[USER_SETTINGS.POLL_RECORD_ATTEMPTS] = RECORD_ATTEMPT.ALL.value;
            const {settings={}} = session;
            if (settings.hasOwnProperty(USER_SETTINGS.POLL_LMS_SYNC)) {
                copy[USER_SETTINGS.POLL_LMS_SYNC] =settings[USER_SETTINGS.POLL_LMS_SYNC]; 
            }
        }
        setUserSettings(copy);
    };


    const saveUserSettings = (settings) => {
        saveSettings(settings).then(() => {
            notifySuccess(SAVE_SETTINGS_SUCCESS);
        });
    };

    return (
        <>
            <SavedLocationsModal
                show={showSavedLocationModal}
                setShow={setShowSavedLocationModal}
                savedLocations={savedLocations}
                setSavedLocations={setSavedLocations}
                userSettings={userSettings}
                setUserSettings={setUserSettings}
                saveSettingsCallback={saveUserSettings}
            />

            <div style={{flex: 1, minWidth: "min(100%, 500px)", display: "flex", flexDirection: "column", gap: 20}}>
                <div className={classes.cardBox} style={{width: "100%"}}>
                    <div className={classes.cardBoxHeader}>
                        <ToastIcon style={{width: 24, height: 24}}/>
                        <span>{TOAST_MESSAGE_SETTINGS}</span>
                    </div>
                    <div className={classes.cardBoxBody}>
                        <div className={classes.settingRow}>
                            <span className={classes.cardDescription}>{USER_TOAST_MESSAGE_LABEL}</span>
                        </div>
                        <YuJaDropdown
                            ariaLabel={TOAST_DROPDOWN + userSettings[USER_SETTINGS.TOAST_MESSAGE_DURATION] + "Seconds"}
                            containerStyle={{maxWidth: 250}}
                            data={optionArr}
                            value={userSettings[USER_SETTINGS.TOAST_MESSAGE_DURATION]}
                            onChange={item => onSelect(item, USER_SETTINGS.TOAST_MESSAGE_DURATION)}
                        />
                    </div>
                </div>

                {!isViewer && <>
                    <div className={classes.cardBox} style={{flex: 1}}>
                        <div className={classes.cardBoxHeader}>
                            <QuestionDetailsIcon/>
                            <span role={TEXTBOX}>{QUESTION_DETAILS_SETTINGS}</span>
                        </div>
                        <div className={classes.cardBoxBody}>
                            <span className={classes.cardDescription}>{USER_QUESTION_MESSAGE_LABEL}</span>

                            <div className={classes.settingRow}
                                 style={{flexDirection: "column", alignItems: "unset", gap: 10}}>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}> {QUESTION_DURATION_LABEL}</div>
                                        <div
                                            className={classes.settingDescription}>{QUESTION_DURATION_DESCRIPTION}</div>
                                    </div>

                                    <div style={{flex: 1}}/>

                                    <YuJaToggle
                                        containerStyle={{flexShrink: 0}}
                                        name={"userSettingsTimeLimitToggle"}
                                        toggled={!!userSettings[USER_SETTINGS.QUESTION_DURATION] && !!parseInt(userSettings[USER_SETTINGS.QUESTION_DURATION])}
                                        onClick={handleToggleQuestionDuration}
                                    />
                                </div>


                                {!!userSettings[USER_SETTINGS.QUESTION_DURATION] && !!parseInt(userSettings[USER_SETTINGS.QUESTION_DURATION]) &&
                                    <DropdownTimeLimit
                                        timeLimit={userSettings.hasOwnProperty(USER_SETTINGS.QUESTION_DURATION)
                                            ? parseInt(userSettings[USER_SETTINGS.QUESTION_DURATION])
                                            : DEFAULT_TIME_LIMIT
                                        }
                                        setTimeLimit={(timeLimit) => {
                                            const copy = JSON.parse(JSON.stringify(userSettings));
                                            copy[USER_SETTINGS.QUESTION_DURATION] = timeLimit;
                                            setUserSettings(copy);
                                        }}
                                    />
                                }
                            </div>
                            <div className={classes.settingRow}
                                 style={{flexDirection: "column", alignItems: "unset", gap: 10}}>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{QUESTION_POINT_LABEL}</div>
                                        <div className={classes.settingDescription}>{QUESTION_POINT_DESCRIPTION}</div>
                                    </div>
                                    <div style={{flex: 1}}/>
                                    <YuJaToggle
                                        name={"userSettingsPointsToggle"}
                                        toggled={!!userSettings[USER_SETTINGS.QUESTION_POINTS] && !!parseInt(userSettings[USER_SETTINGS.QUESTION_POINTS])}
                                        onClick={handleToggleQuestionPoints}
                                    />
                                </div>


                                {!!userSettings[USER_SETTINGS.QUESTION_POINTS] && !!parseInt(userSettings[USER_SETTINGS.QUESTION_POINTS]) &&
                                    <DropdownWeightage
                                        weightage={userSettings.hasOwnProperty(USER_SETTINGS.QUESTION_POINTS)
                                            ? parseInt(userSettings[USER_SETTINGS.QUESTION_POINTS])
                                            : DEFAULT_POINTS}
                                        setWeightage={(weightage) => {
                                            const copy = JSON.parse(JSON.stringify(userSettings));
                                            copy[USER_SETTINGS.QUESTION_POINTS] = weightage;
                                            setUserSettings(copy);
                                        }}
                                        isFromSettingsPage={true}
                                    />

                                }
                            </div>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{COUNTDOWN_TIMER_LABEL}</div>
                                    <div
                                        className={classes.settingDescription}>{QUESTION_COUNTDOWN_TIMER_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>

                                <TimeLimitInput
                                    timeLimit={userSettings[USER_SETTINGS.QUESTION_COUNTDOWN]}
                                    setTimeLimit={(timeLimit) => {
                                        const copy = JSON.parse(JSON.stringify(userSettings));
                                        copy[USER_SETTINGS.QUESTION_COUNTDOWN] = timeLimit;
                                        setUserSettings(copy);
                                    }}
                                    unit={"MM:SS"}
                                    minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                                    reachMinValErrorText={MINIMUM_COUNT_DOWN_SETTING_ERROR}
                                />
                            </div>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{MAXIMUM_ENTRIES_LABEL}</div>
                                    <div className={classes.settingDescription}>{MAXIMUM_ENTRIES_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>

                                <YuJaTextBox
                                    containerStyle={{width: 50, height: 35}}
                                    inputAlign={"center"}
                                    min="1"
                                    max="10"
                                    value={`${userSettings[USER_SETTINGS.QUESTION_ENTRIES]}`}
                                    onChange={onChangeCustomEntries}
                                    onBlur={() => {
                                        const copy = JSON.parse(JSON.stringify(userSettings));
                                        if (userSettings[USER_SETTINGS.QUESTION_ENTRIES] === "") {
                                            copy[USER_SETTINGS.QUESTION_ENTRIES] = DEFAULT_ENTRIES_PER_PARTICIPANT;
                                            notifyError(SETTINGS_QUESTION_ENTRIES_MIN_ERROR);
                                        } else if (userSettings[USER_SETTINGS.QUESTION_ENTRIES] > WC_MAXIMUM_ENTRIES) {
                                            parseInt(userSettings[USER_SETTINGS.QUESTION_ENTRIES])
                                            copy[USER_SETTINGS.QUESTION_ENTRIES] = WC_MAXIMUM_ENTRIES;
                                            notifyError(SETTINGS_QUESTION_ENTRIES_MAX_ERROR);
                                        } else if (userSettings[USER_SETTINGS.QUESTION_ENTRIES] <= 0) {
                                            copy[USER_SETTINGS.QUESTION_ENTRIES] = DEFAULT_ENTRIES_PER_PARTICIPANT;
                                            notifyError(SETTINGS_QUESTION_ENTRIES_MIN_ERROR);
                                        } else {
                                            copy[USER_SETTINGS.QUESTION_ENTRIES] = parseInt(userSettings[USER_SETTINGS.QUESTION_ENTRIES]);
                                        }
                                        setUserSettings(copy);

                                    }}
                                    placeholder={"1"}
                                    type={"number"}
                                />
                            </div>


                            {/*class result duration*/}
                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>
                                        {CLASS_RESULT_DURATION_LABEL}
                                    </div>
                                    <div className={classes.settingDescription}>
                                        {PARTICIPANTS_VIEW_CLASS_RESULT_DESCRIPTION}
                                    </div>
                                </div>
                                <div style={{flex: 1}}/>
                                <TimeLimitInput
                                    timeLimit={userSettings[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION]}
                                    setTimeLimit={(timeLimit) => {
                                        const copy = JSON.parse(JSON.stringify(userSettings));
                                        copy[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION] = timeLimit;
                                        setUserSettings(copy);
                                    }}
                                    unit={"MM:SS"}
                                    minVal={DEFAULT_CLASS_RESULT_TIME_LIMIT}
                                    reachMinValErrorText={MINIMUM_CLASS_RESULT_DURATION_SETTING_ERROR}
                                />
                            </div>
                        </div>
                    </div>
                </>
                }

            </div>
            {!isViewer &&
                <div style={{flex: 1, minWidth: "min(100%, 500px)"}}>
                    <div className={classes.cardBox} style={{width: "100%"}}>
                        <div className={classes.cardBoxHeader}>
                            <PollDetailsIcon/>
                            <span>{ACTIVITY_DETAILS_SETTINGS}</span>
                        </div>
                        <div className={classes.cardBoxBody}>
                            <span className={classes.cardDescription}>{ACTIVITY_DETAILS_SETTINGS_DESCRIPTION}</span>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{COUNTDOWN_TIMER_LABEL}</div>
                                    <div className={classes.settingDescription}>{POLL_COUNTDOWN_TIMER_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>

                                <TimeLimitInput
                                    timeLimit={userSettings[USER_SETTINGS.POLL_COUNTDOWN]}
                                    setTimeLimit={(timeLimit) => {
                                        const copy = JSON.parse(JSON.stringify(userSettings));
                                        copy[USER_SETTINGS.POLL_COUNTDOWN] = timeLimit;
                                        setUserSettings(copy);
                                    }}
                                    unit={"MM:SS"}
                                    minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                                    reachMinValErrorText={MINIMUM_COUNT_DOWN_SETTING_ERROR}
                                />
                            </div>
                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{REQUIRE_PARTICIPANTS_NAME}</div>
                                    <div
                                        className={classes.settingDescription}>{REQUIRE_PARTICIPANTS_NAME_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaToggle
                                    containerStyle={{flexShrink: 0}}
                                    name={"userSettingsParticipantsRestrictionToggle"}
                                    toggled={userSettings[USER_SETTINGS.POLL_REQUIRED_NAME] === "true" || userSettings[USER_SETTINGS.POLL_REQUIRED_NAME] === true}
                                    onClick={handleAnonymousJoinSettingChange}
                                />
                            </div>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{SHOW_CORRECT_ANSWER}</div>
                                    <div className={classes.settingDescription}>{SHOW_CORRECT_ANSWER_DESCRIPTION}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaToggle
                                    containerStyle={{flexShrink: 0}}
                                    name={"userSettingsShowCorrectAnswerToggle"}
                                    toggled={userSettings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] === "true" || userSettings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] === true}
                                    onClick={handleCorrectAnswerChange}
                                />
                            </div>

                            <div style={{display: "flex", flexDirection: "column", gap: 10}}>
                                <span className={classes.settingLabel}> {RECORD_ATTEMPT_TITLE} </span>
                                <div style={{display: "flex", flexDirection: "column", gap: 10}}>
                                    {Object.entries(recordAttemptOptions.current).map((optionData, index) => {
                                        const {value, label} = optionData[1];
                                        return (
                                            <YuJaRadioBox
                                                key={index}
                                                aria-label={label + RADIAL_LABEL + (value === userSettings[USER_SETTINGS.POLL_RECORD_ATTEMPTS] ? "selected" : "unselected")}
                                                label={label}
                                                style={{width: "fit-content"}}
                                                checked={value === userSettings[USER_SETTINGS.POLL_RECORD_ATTEMPTS]}
                                                onClick={() => handleRecordAttemptOptionClick(value)}
                                            />
                                        );
                                    })}
                                </div>
                            </div>

                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>{GRADE_BOOK_TEXT}</div>
                                    <div
                                        className={classes.settingDescription}>{ATTEMPT_SYNC_TO_GRADE_BOOK_DESCRIPTION}</div>
                                </div>

                                <div style={{flex: 1}}/>

                                <YuJaDropdown
                                    ariaLabel={ATMPT_DROPDOWN + userSettings[USER_SETTINGS.POLL_LMS_SYNC]}
                                    containerStyle={{width: 250, flexShrink: 0}}
                                    data={attemptSettingsArr}
                                    value={userSettings[USER_SETTINGS.POLL_LMS_SYNC]}
                                    onChange={handleLMSAttemptSettingChange}
                                    size={YUJA_DROPDOWN_SIZE.SMALL}
                                    disabled={userSettings[USER_SETTINGS.POLL_RECORD_ATTEMPTS] === SYNC_ATTEMPT.RECENT.value}
                                />
                            </div>

                            {/*Poll max Attempts*/}
                            <div className={classes.settingRow} style={{flexDirection: "column", alignItems: "unset"}}>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{POLL_ATTEMPT_SETTINGS_TEXT}</div>
                                        <div
                                            className={classes.settingDescription}>{UNLIMITED_MAX_ATTEMPTS_SETTING_TEXT}</div>
                                    </div>

                                    <div style={{flex: 1}}/>
                                    <YuJaToggle
                                        containerStyle={{flexShrink: 0}}
                                        name={"userSettingsUnlimitedAttemptsToggle"}
                                        toggled={!userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS] || parseInt(userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS]) < 0}
                                        onClick={onChangeMaximumAttempts}
                                    />
                                </div>

                                {!!userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS] && parseInt(userSettings[USER_SETTINGS.POLL_MAX_ATTEMPTS]) > 0 &&
                                    <div style={{display: "flex", alignItems: "center", gap: 15}}>
                                        <span
                                            className={classes.settingDescription}>{"Set maximum attempts allowed."}</span>
                                        <div style={{flex: 1}}/>
                                        <YuJaTextBox
                                            containerStyle={{width: 50, height: 35}}
                                            inputAlign={"center"}
                                            value={maxAttempts}
                                            onChange={(e) => setMaxAttempts(e.target.value)}
                                            placeholder={"1"}
                                            min="1"
                                            type={"number"}
                                            onBlur={() => {
                                                const copy = JSON.parse(JSON.stringify(userSettings));
                                                if (!maxAttempts) {
                                                    copy[USER_SETTINGS.POLL_MAX_ATTEMPTS] = -1;
                                                } else if (parseInt(maxAttempts) > 0) {
                                                    copy[USER_SETTINGS.POLL_MAX_ATTEMPTS] = parseInt(maxAttempts);
                                                    setMaxAttempts(`${parseInt(maxAttempts)}`);
                                                } else {
                                                    copy[USER_SETTINGS.POLL_MAX_ATTEMPTS] = -1;
                                                }
                                                setUserSettings(copy);

                                            }}
                                        />
                                    </div>
                                }
                            </div>


                            {/*Activity time limit*/}
                            <div className={classes.settingRow} style={{flexDirection: "column"}}>
                                <div className={classes.settingRow}>
                                    <div>
                                        <div className={classes.settingLabel}>{ACTIVITY_LENGTH_SETTING_TEXT}</div>
                                        <div className={classes.settingDescription}>{ACTIVITY_LENGTH_SETTING_DESC}</div>
                                    </div>

                                    <div style={{flex: 1}}/>

                                    <YuJaToggle
                                        containerStyle={{flexShrink: 0}}
                                        name={"userSettingsCloseAttendanceToggle"}
                                        toggled={userSettings[USER_SETTINGS.ATTENDANCE_MANUAL_END] === "true" || userSettings[USER_SETTINGS.ATTENDANCE_MANUAL_END] === true}
                                        onClick={handleAttendanceManualEndChange}
                                    />
                                </div>

                                {(userSettings[USER_SETTINGS.ATTENDANCE_MANUAL_END] === "false" || userSettings[USER_SETTINGS.ATTENDANCE_MANUAL_END] === false) &&
                                    <div className={classes.settingRow}>
                                        <div>
                                            <div className={classes.settingLabel}>
                                                {ACTIVITY_TIME_LIMIT_TEXT}
                                            </div>
                                            <div className={classes.settingDescription}>
                                                {PARTICIPANT_TIME_INTRO
                                                    .replaceAll(ACTIVITY_TYPE_PLACEHOLDER, deCapitalizeWord(ACTIVITY_TEXT))}
                                            </div>
                                        </div>
                                        <div style={{flex: 1}}/>
                                        <TimeLimitInput
                                            timeLimit={userSettings[USER_SETTINGS.POLL_DURATION]}
                                            setTimeLimit={(timeLimit) => {
                                                const copy = JSON.parse(JSON.stringify(userSettings));
                                                copy[USER_SETTINGS.POLL_DURATION] = timeLimit;
                                                if (!timeLimit) {
                                                    copy[USER_SETTINGS.ATTENDANCE_MANUAL_END] = true;
                                                }
                                                setUserSettings(copy);
                                            }}
                                            unit={"HH:MM"}
                                        />
                                    </div>

                                }
                            </div>


                            {/*poll break duration*/}
                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>
                                        {POLL_BREAK_DURATION_LABEL}
                                    </div>
                                    <div className={classes.settingDescription}>
                                        {POLL_END_FLEXIBLE_TIME_DESCRIPTION.replaceAll(ACTIVITY_TYPE_PLACEHOLDER, deCapitalizeWord(POLL_TEXT))}
                                    </div>
                                </div>

                                <div style={{flex: 1}}/>
                                <TimeLimitInput
                                    timeLimit={userSettings[USER_SETTINGS.POLL_BREAK_DURATION]}
                                    setTimeLimit={(timeLimit) => {
                                        const copy = JSON.parse(JSON.stringify(userSettings));
                                        copy[USER_SETTINGS.POLL_BREAK_DURATION] = timeLimit;
                                        setUserSettings(copy);
                                    }}
                                    unit={"MM:SS"}
                                    minVal={DEFAULT_POLL_BREAK_TIME_LIMIT}
                                    reachMinValErrorText={MINIMUM_POLL_BREAK_DURATION_SETTING_ERROR}
                                />

                            </div>


                            <div className={classes.settingRow}>
                                <div>
                                    <div className={classes.settingLabel}>
                                        {GEOFENCED_LOCATIONS_TITLE}
                                    </div>
                                    <div className={classes.settingDescription}>
                                        {ATTENDANCE_SETTINGS_GEO_LOCATION_SUB_TITLE}
                                    </div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaButton
                                    style={{whiteSpace: "nowrap"}}
                                    onClick={() => setShowSavedLocationModal(true)}
                                >
                                    {CONFIGURE_LOCATIONS_TEXT}
                                </YuJaButton>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}